import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ItemSetting} from "../../../price-plan/models/itemSetting.model";

export class PackagesDisplayListCtrl implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;
  disabledIds: any;

  onChange: Function;

  private readonly sitePackageItems: ItemSetting[];
  private displayItems: any;

  constructor(private splitService, private $log) {
    this.sitePackageItems = this.splitService.getSitePackageItems();
  }

  $onInit() {

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      const displayItems = [];
      _.forEach(this.sitePackageItems, (p) => {
        if (_.includes(ids, p.id)) {
          displayItems.push({id: p.id, value: p.name})
        }
      })
      this.displayItems = displayItems;
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('packagesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      disabledIds: '<?',
      onChange: '&'
    },
    template: require('./packages-display-list.html').default,
    controller: PackagesDisplayListCtrl
  });
